import * as React from "react";
import type { SVGProps } from "react";
const SvgBedFor1Person = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 10.18V4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v6.18c-1.16.41-2 1.51-2 2.82v7c0 .55.45 1 1 1s1-.45 1-1v-2h16v2c0 .55.45 1 1 1s1-.45 1-1v-7c0-1.3-.84-2.4-2-2.82M6 5h12v5h-1V9c0-1.65-1.35-3-3-3h-4C8.35 6 7 7.35 7 9v1H6zm9 5H9V9c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zM4 13c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3H4z"
    />
  </svg>
);
export default SvgBedFor1Person;
